import {post_data} from './API_Calls.js';
import * as ReportObjects from './ReportObjects';
export let incident_list: ReportObjects.RouteIncident[] = [];

export const getRouteTemplate = async () => {
    const parameters = {
        "route_template_uuid" : ReportObjects.template_uuid,
        "is_deleted": false
    }
    try {
        const res = await post_data("/get_RouteTemplate", parameters );

        const template: ReportObjects.RouteTemplate | null = res[0] ? ReportObjects.formatRouteTemplate(res[0]) : null;
        return template;
    } catch (error) {
        console.error(error);
    }
}
///   CURRENTLY INCIDENTS IS NOT TAKEN INTO ACCOUNT
export async function routeTemplateAnalyse(route_template: ReportObjects.RouteTemplate | null, user_uuid, coordinate_format = "D", incidents = false, radius = 0, months = 0) {
    try {
        var route_json = JSON.parse(JSON.stringify(route_template));
        route_json.geojson_text = JSON.parse(route_json.geojson_text);

        var param = {
            "user_account_uuids" : [user_uuid],
            "parent_account_uuids" : [],
            "user_emails": []
        };

        let res_user = await post_data("/get_MariTraceUserAccount", param);
        ReportObjects.updateAccountDetails(res_user[0], '');
        //let res_parent = await post_data("/get_MariTraceParentAccount", [ReportObjects.getUserAccount().maritrace_parent_account.parent_account_uuid]);
        /*if(ReportObjects.getUserAccount().maritrace_parent_account.parent_account_uuid != ''){
            ReportObjects.updateAccountDetails(ReportObjects.getUserAccount().maritrace_parent_account, '', true);
        }*/

        const route_analysis_parameters = {
            route_name: route_json.name,
            etd: route_json.etd,
            coordinate_format: coordinate_format,
            vessel_uuid: (route_json.vessel && route_json.vessel.vessel_identifier) ? route_json.vessel.vessel_identifier : null,
            vessel_name: (route_json.vessel == null ? "" : route_json.vessel.name),
            vessel_type_group: 0,
            email_address: "",
            return_risk: true,
            return_geography: true,
            user: ReportObjects.getUserAccount(),
            parent: ReportObjects.getUserAccount().maritrace_parent_account,
            route: route_json.geojson_text
        };

        //const res_analysis = await post_data("/AnalyseRoute_NewService", route_analysis_parameters);
        const res_analysis = await post_data("/AnalyseRoute", route_analysis_parameters);
        let analysis : ReportObjects.AnalysedRoute = res_analysis ? ReportObjects.formatAnalysedRoute(res_analysis) : null;
        if (!analysis) return null;
        analysis.etd = formatDateToYYYYMMDDHHMM(new Date(analysis.etd));
        analysis.eta = formatDateToYYYYMMDDHHMM(new Date(analysis.eta));
        if (route_json && route_json.name) {
            analysis.route_name = route_json.name;
        }
        const { risk_level, color, text_color } = determineRiskLevelAndColor(analysis.max_risk);
        analysis.max_risk_string = risk_level;
        analysis.max_risk_color = color;
        analysis.max_risk_text_color = text_color;
        return analysis;
    } catch (error) {
        console.error(error);
    }
}

export function determineRiskLevelAndColor(max_risk) {
    let risk_level, color, text_color;
    text_color = "#000000";
    if (max_risk <= 0) {
        risk_level = "LOW";
        color = "#00FF00"; // Green
    } else if (max_risk <= 5) {
        risk_level = "MEDIUM-LOW";
        color = "#80FF00"; // Between green and yellow
    } else if (max_risk <= 10) {
        risk_level = "MEDIUM";
        color = "#FFFF00"; // Yellow
    } else if (max_risk <= 15) {
        risk_level = "MEDIUM-HIGH";
        color = "#FFA500"; // Orange
    } else if (max_risk <= 20) {
        risk_level = "HIGH";
        color = "#FF0000"; // Red
        text_color = "#ffffff";
    } else if (max_risk < 25) {
        risk_level = "VERY-HIGH";
        color = "#8B0000"; // Dark Red
        text_color = "#ffffff";
    } else {
        risk_level = "EXTREME";
        color = "#800000"; // Maroon
        text_color = "#ffffff";
    }

    return { risk_level, color, text_color};
}

export async function get_incident_data(route_param: ReportObjects.report_info){
    let start_date = new Date().toISOString();
    let end_date = new Date();
    end_date.setMonth(end_date.getMonth() - document.getElementById("incidents_in_months").value);
    end_date = end_date.toISOString();

    let radius = document.getElementById("incidents_in_radius").value;
    let unit = document.getElementById("incidents_radius_metric").value;

    let route_array = [];
    for(let i = 0; i < route_param.route.length; i++){
        let route_pos = {
            date_reached:route_param.route[i].date_reached,
            lat:route_param.route[i].position_location.dec.lat,
            lon:route_param.route[i].position_location.dec.lon
        }
        route_array.push(route_pos);
    }

    const param = {
        start_date : start_date,
        end_date : end_date,
        distance : radius,
        measurement : unit,
        search_route : route_array
    };
    console.log("find_routeIncidents: ", param);
    const res_inc = await post_data("/find_routeIncidents", param);
    incident_list = [];
    for(let i = 0; i < res_inc.length; i++){
        const incident : ReportObjects.RouteIncident = res_inc[i] ? ReportObjects.formatRouteIncident(res_inc[i]) : null;
        if(incident){
            incident_list.push(incident);
        }
    }

    return [incident_list, radius.toString(), unit.toUpperCase(), document.getElementById("incidents_in_months").value];
}

export async function get_incident_data_optimised(route_param: ReportObjects.report_info){
	let start_date = new Date().toISOString();
	let end_date = new Date();
	end_date.setMonth(end_date.getMonth() - document.getElementById("incidents_in_months").value);
	end_date = end_date.toISOString();

	let radius = document.getElementById("incidents_in_radius").value;
	let unit = document.getElementById("incidents_radius_metric").value;

	let route_array = [];
	for(let i = 0; i < route_param.route.length; i++){
		let route_pos = {
			lat: route_param.route[i].position_location.dec.lat,
			lon: route_param.route[i].position_location.dec.lon
		}
		route_array.push(route_pos);
	}

	const param = {
		start_date : start_date,
		end_date : end_date,
		distance : radius,
		measurement : unit,
		search_route : route_array
	};

	const res_inc = await post_data("/find_routeIncidents_optimised", param);
	incident_list = [];
	for(let i = 0; i < res_inc.length; i++){
		const incident : ReportObjects.RouteIncident = res_inc[i] ? ReportObjects.formatRouteIncident_optimised(res_inc[i]) : null;
		if(incident){
			incident_list.push(incident);
		}
	}

	return [incident_list, radius.toString(), unit.toUpperCase(), document.getElementById("incidents_in_months").value];
}

function formatDateToYYYYMMDDHHMM(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
}
